import { useMemo } from "react"
import dayjs from "config/dayjs"
import { useVenue } from "providers/venue"
import { CalendarStarIcon, PercentIcon } from "../../components/icons"

export const useHome = () => {
  const { features, venues, locales, dataLoaded } = useVenue()

  // Prepare promotion and event list for showing at the carousel
  const featuredEventPromotion = useMemo(
    () =>
      features
        .filter(
          ({ feature_type, properties }) =>
            ["promotion", "event"].includes(feature_type) &&
            properties.is_featured
        )
        .sort(
          (a, b) =>
            dayjs(a.properties.start_date) - dayjs(b.properties.start_date)
        ),
    [features]
  )

  const defaultItemsLinks = [
    {
      to: "/events",
      primaryText: "View All Event",
      secondaryText: "See more events that match your lifestyle",
      icon: <CalendarStarIcon />,
    },
    {
      to: "/promotions",
      primaryText: "View All Promotion",
      secondaryText: "See more special deals and get special offers",
      icon: <PercentIcon />,
    },
  ]

  return {
    featuredEventPromotion,
    defaultItemsLinks,
    venues,
    locales,
    dataLoaded,
  }
}
